import type { Mission } from "@/features/missionkit/api/use-mission";

/** Explicit HelpText (including empty text) wins; older APIs retain their old layout. */
export function missionCopy(mission: Pick<Mission, "mission" | "helpText">) {
  const text = mission.mission
    .replace(/^your mission:\s*/i, "")
    .trim()
    .replace(/^./, (c) => c.toUpperCase());
  if (typeof mission.helpText === "string") {
    return { headline: text, detail: mission.helpText.trim() };
  }
  const sentences = text.match(/[^.?!]+[.?!]+[”’"']*\s*/g);
  const whole = sentences?.join("").trim().length === text.length;
  return whole && sentences
    ? {
        headline: sentences[0].trim(),
        detail: sentences.slice(1).join("").trim(),
      }
    : { headline: text, detail: "" };
}
